<template>
  <div>
    <topbar :slim="$store.getters.screenXL">
      <div class="flex flex-1 p-2 py-4 items-center text-white text-2xl leading-none font-display">
        <div
          class="rounded-md h-12 w-12 overflow-hidden bg-white bg-center bg-cover mr-2"
          :style="{
            backgroundImage: $store.getters.userPic ? `url('${$store.getters.userPic}')` : false
          }"
        ></div>
        <div class="flex-1 mx-2">
          {{$t('hello')}}
          <br />
          <b>{{$store.getters.friendlyName}}</b>
        </div>
        <router-link class="ml-2" :to="{name: 'Profile'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45">
            <path
              d="M37.3 8.22a4.2 4.2 0 00-5.92 0l-1.64 1.64L9.05 30.55l-.02.02a.68.68 0 00-.1.16.43.43 0 00-.03.05.61.61 0 00-.06.11l-1.81 6.77a.68.68 0 00.66.86.67.67 0 00.17-.03l6.77-1.81a.73.73 0 00.1-.06l.05-.03a.66.66 0 00.16-.1l.03-.03 20.7-20.69 1.63-1.63a4.2 4.2 0 000-5.92zM8.64 36.87l1.2-4.48 3.27 3.28zm5.84-1.85l-3.99-3.99 19.72-19.72 3.99 3.98zm21.84-21.85l-1.16 1.15-3.98-3.98 1.15-1.15a2.82 2.82 0 013.99 3.98z"
              fill="#fff"
            />
          </svg>
        </router-link>
      </div>
    </topbar>

    <card type="square">
      <div class="flex p-2 px-3 max-w-3xl xl:max-w-6xl xl:px-0 mx-auto w-full">
        <div class="flex flex-grow items-center mr-2">
          <div class="flex-grow relative h-4 bg-secondary_text">
            <div
              class="absolute bg-brand-1 h-full border-r-2 border-white"
              :style="{width: `${$store.getters.points}%`}"
            ></div>
          </div>
          <div class="flex-shrink p-2 text-brand-1 text-lg">{{$store.getters.points}}</div>
        </div>
        <div class="flex flex-shrink items-center ml-2">
          <div class="p-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45">
              <g transform="translate(-2.7)" fill="#e3064a">
                <circle cx="12" cy="12" r="12" transform="translate(12.97 4)" />
                <path
                  d="M40.47 37.65L36.59 23.8a13.98 13.98 0 01-10.87 6.16l3.14 10.95a.8.8 0 00.63.58.74.74 0 00.15.01.82.82 0 00.65-.33l3.55-4.82 5.54 2.28a.81.81 0 001.09-.98zM13.53 24.06l-3.8 13.6a.81.81 0 001.1.97l5.53-2.28 3.55 4.82a.82.82 0 00.66.33.75.75 0 00.14-.01.81.81 0 00.64-.58l3.13-10.93a13.97 13.97 0 01-10.95-5.92z"
                />
              </g>
            </svg>
          </div>
          <div class="text-brand-1 text-lg">{{$store.getters.level}}</div>
        </div>
      </div>
    </card>

    <div v-if="newMaps.length" class="mb-4">
      <div class="px-3 xl:px-0 pt-4 pb-1  max-w-3xl xl:max-w-6xl mx-auto w-full">Esplora le tue mappe</div>
      <div class="relative">
        <div class="relative z-10 pointer-events-none">
          <slider ref="mapslider" class="">
            <div class="p-3 xl:px-0 max-w-3xl xl:max-w-6xl mx-auto w-full pointer-events-auto" v-for="map of newMaps" :key="`map-${map.word}`">
              <card type="round-no-pad" class="w-full">
                
                <div class="p-3">{{map.word}}</div>
                <div class="aspect-ratio-16/9 relative ">
                  <div class="absolute top-0 left-0 w-full h-full overflow-hidden z-10">
                    <wordmap-loader :url="map.gsurl" :controls="false" />
                  </div>
                </div>
              </card>
            </div>
          </slider>
        </div>

        <div v-if="$refs.mapslider" class="hidden lg:block absolute top-0 left-0 w-full h-full pointer-events-none ">
          <div class="max-w-3xl xl:max-w-6xl h-full w-full mx-auto flex items-center relative">
            <div @click="$refs.mapslider.prev()" style="will-change: opacity" :class="{'opacity-0': $refs.mapslider.index === 0 }" class="cursor-pointer absolute pointer-events-auto transform -translate-x-full" v-icon="'triangle-left'"></div>
            <div @click="$refs.mapslider.next()" style="will-change: opacity" :class="{'opacity-0': $refs.mapslider.index >= newMaps.length - 1 }" class="cursor-pointer absolute pointer-events-auto right-0 transform translate-x-full" v-icon="'triangle-right'"></div>
          </div>
        </div>
      </div>


    </div>

    <div class="p-3 xl:px-0  max-w-3xl xl:max-w-6xl mx-auto w-full">
      <div class="py-3">{{$t('todo-list')}}</div>
      <template v-if="todolist.length">
        <router-link :to="item.target" v-for="item in truncatedTodoList" :key="item.key">
          <card>
            <div
              class="text-secondary_text"
            >{{item.time.toLocaleDateString('it-CH', {dateStyle: 'long'})}}</div>
            <div class="font-bold">{{item.title}}</div>
            <div v-if="item.subtitle">{{item.subtitle}}</div>
          </card>
        </router-link>

        <div v-if="todolist.length > 5" class="py-4">
          <button @click="showAll = !showAll" class="text-brand-1">
            {{showAll ? $t('show-less-activities') : $t('show-more-activities')}}
          </button>
        </div>
      </template>
      <div class="text-secondary_text" v-else>
        Complimenti! Hai completato tutte le attività
      </div>
    </div>


  </div>
</template>

<script>
import { mapGetters } from "vuex";

import WordmapLoader from "@/components/maps/WordmapLoader.vue";

export default {
  components: {
    WordmapLoader,
  },

  data() {
    return {
      showAll: false,
    };
  },

  methods: {},

  computed: {
    ...mapGetters("surveys", ["words", "incompleteSurveys"]),

    newMaps() {
      if(this.words) {
        return Object.entries(this.words)
          .sort((a, b) => b[1].visited - a[1].visited)
          .slice(0, 5)
          .map(([, wordData]) => {
            const chosen = wordData.answers.find(a => a.used === 1) || wordData.answers[0];
            return {
              word: chosen.text,
              gsurl: chosen.url,
            }
          });
        
      } else {
        return []
      }
    },

    truncatedTodoList() {
      if(this.showAll) {
        return this.todolist;
      } else {
        return this.todolist.slice(0, 5);
      }
    },

    todolist() {
      const surveys = this.incompleteSurveys.map((survey) => {
        const surveyId = survey.id;

        return {
          key: `survey/${surveyId}`,
          time: new Date(survey.date),
          target: { name: "Survey", params: { id: surveyId } },
          title: "Come lo dici?",
          subtitle: survey.title,
        };
      });

      
      return surveys.sort((a, b) => b.time - a.time);
    },
  },
};
</script>

<style>

</style>